export default {
    toggle: $('.featured-series-tab-inner .featured-series-tab-title'),
    content: $('.featured-series-tab-content'),

    init: function () {
        this.container = $('.blog_series_taxonomy-feed');
        if (this.container.length < 1) return;
        this.bindEvents();
    },

    toggleActive: function ($$) {
        let parent = $$.parent('.featured-series-tab-inner'),
            content = parent.find('.featured-series-tab-content');

        if (parent.hasClass('open')) {
            parent.removeClass('open');
            content.slideUp();
        } else {
            $('.featured-series-tab-inner').removeClass('open');
            parent.addClass('open');
            $('.featured-series-tab-content').slideUp();
            content.slideDown();
        }
    },


    bindEvents: function () {
        let _this = this;

        this.toggle.click(function () {
            _this.toggleActive($(this));
        });

        $(document).click(function () {
            let tab = $('.featured-series-tab-inner');
            tab.removeClass('open');
            $('.featured-series-tab-content').slideUp();
        });
        $('.featured-series-tab ,.featured-series-tab-inner .featured-series-tab-title').click(function (e) {
            e.stopPropagation();
        });


    },
};
